import Dialog from '@jetbrains/ring-ui/components/dialog/dialog'
import {memo, useCallback} from 'react'

import {useAppSelector} from '../../../../../../hooks/react-redux'
import {useBooleanQueryParamState} from '../../../../../../hooks/routes'
import type {BuildId} from '../../../../../../types'
import type {PreloadedEntryPoints} from '../../../../../../types/entryPoints'
import {PipelinesTarget, PipelinesTargetContext} from '../../../contexts/targetContext'
import type {NestedEntryPoints} from '../../PipelineRunPage'
import JobDetails from '../JobDetails/JobDetails'

import styles from './JobDetailsPopup.css'

type Props = {
  jobId: BuildId | null | undefined
  entryPoints: PreloadedEntryPoints<NestedEntryPoints>
}

function JobDetailsPopup({jobId, entryPoints}: Props) {
  const marginBottom = useAppSelector(state => state.toolPanelFooter.height)

  const [isJobDetailsFullscreen, setJobDetailsFullscreen] = useBooleanQueryParamState(
    'jobDetailsFullscreen',
    false,
  )

  const onCloseAttempt = useCallback(() => {
    setJobDetailsFullscreen(false, true)
  }, [setJobDetailsFullscreen])

  if (!isJobDetailsFullscreen) {
    return null
  }

  return (
    <Dialog
      label="Build Log"
      className={styles.overlay}
      contentClassName={styles.dialog}
      onCloseClick={onCloseAttempt}
      style={{marginBottom}}
      autoFocusFirst={false}
      trapFocus
      show
    >
      <PipelinesTargetContext.Provider value={PipelinesTarget.JOB_DETAILS_POPUP}>
        <JobDetails className={styles.details} jobId={Number(jobId)} entryPoints={entryPoints} />
      </PipelinesTargetContext.Provider>
    </Dialog>
  )
}

export default memo(JobDetailsPopup)
